
import { useState } from "react";
import { useNavigate } from "react-router";
import Form from "../../../../components/common/form/Form";
import Modal from "../../../../components/common/form/Modal";
import CommonSelectorModal from "../../../../components/common/form/CommonSelectorModal";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { FaLink, FaMagnifyingGlass } from "react-icons/fa6";
import { useSearchCollectorQuery } from "../collector";
import InputField from "../../../../components/common/form/InputField";
import IconButton from "../../../../components/common/form/IconButton";
import { FaSearch, FaTimes } from "react-icons/fa";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { useUpdateJurisdictionsCollectorMutation } from "../../jurisdiction/jurisdictionApi";
import { Routes as AppRoutes } from "../../../../routes";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

interface Collector {
    id: number;
    name: string;
}

interface Props {
    show: boolean;
    setShow: (show: boolean) => void;
    collectorJurisData: any
    authorities?: string[];
    deleteTobeCollectorId: any;
}

export default function JurisCollectorUpdateForm({
    show,
    setShow,
    collectorJurisData,
    deleteTobeCollectorId
}: Props) {

    const [collectorObj, setCollectorObj] = useState<Collector | null>(null);
    const [showCollectorModal, setShowCollectorModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>({});
    const [updateJurisdictionsCollector, updateJurisdictionsCollectorRes] = useUpdateJurisdictionsCollectorMutation();
    const iconButtonStyle = "fa cursor-pointer text-highlight-0 absolute left-auto right-5 top-6";
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (collectorObj && deleteTobeCollectorId && selectedRow?.id) {
            await updateJurisdictionsCollector({
                jurisdictionIds: collectorJurisData?.data?.map((el: any) => el.id),
                collectorId: selectedRow.id,
                deleteCollectorId: deleteTobeCollectorId
            });

            setShow(false);
            navigate(AppRoutes.Collector.path)
        }
    };

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }],
        },

    ]

    const handleOnClick = (e: any, name: string) => {
        e.preventDefault();
        setCollectorObj(selectedRow)
        setShowCollectorModal(false)
    }

    const handleClearField = () => {
        setCollectorObj(null);
    };

    return (
        <>
            <Modal
                title={"Migrate Jurisdictions to new Collector"}
                show={show}
                setShow={setShow}
                className={"w-2/5 bg-text-0 text-surface-0"}
                fields={
                    <>
                        <Form
                            onSubmit={handleSubmit}
                            fields={
                                <>
                                    <div className="modal-body mr-auto">
                                        <p>
                                            You are about to delete the selected collector. Please select a new collector for these
                                            following jurisdictions before proceeding.
                                        </p>
                                        <InputField
                                            name="collector"
                                            label="Collector"
                                            value={collectorObj !== null ? collectorObj?.name : ""}
                                            type="text"
                                            placeholder="Enter Collector..."
                                            icon={<IconButton
                                                icon={<FaLink onClick={() => {
                                                    if (hasPermission(["COLL-R"]) && selectedRow?.id) {
                                                        window.open(`/collectors/${selectedRow.id}`, '_blank');
                                                    }
                                                }} />
                                                }
                                                className={`text-lg ${collectorObj ? 'text-highlight-4 ' : 'text-surface-4'
                                                    }`}
                                                title={"Go To Collector"}
                                            />}
                                            required
                                            onClick={() => setShowCollectorModal(true)}
                                            className="cursor-pointer"
                                            inputIcon={
                                                collectorObj ? (
                                                    <FaTimes
                                                        className={iconButtonStyle}
                                                        title="Clear Collector"
                                                        onClick={() => handleClearField()}
                                                    />
                                                ) : (
                                                    <FaSearch
                                                        className={iconButtonStyle}
                                                        title="Add Module Name"
                                                        onClick={() => setShowCollectorModal(true)}
                                                    />
                                                )

                                            }
                                        />


                                        <div className={collectorJurisData?.data?.length > 10 ? "h-[537px] overflow-scroll" : undefined}>
                                            <table className="table table_data table-hover table-striped w-full mt-3">
                                                <thead className={`bg-highlight-5 text-text-0 relative text-left ${collectorJurisData?.data?.length > 10 ? "sticky top-0" : ""}`}
                                                >
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Jurisdiction Name</th>
                                                        <th>State</th>
                                                        <th>County</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="table-striped text-md">
                                                    {collectorJurisData?.data?.map((el: any, index: any) => (
                                                        <tr key={index} className="odd:bg-text-1 hover:bg-text-1 transition cursor-pointer">
                                                            <td>{index + 1}</td>
                                                            <td>{el.name}</td>
                                                            <td>{el?.county?.state?.stateName || "-"}</td>
                                                            <td>{el?.county?.countyName || "-"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="mt-8 border-t border-surface-5">
                                        <ButtonTray
                                            buttons={[
                                                {
                                                    buttonProps: {
                                                        btnText: "Cancel",
                                                        onClick: () => setShow(false),
                                                        type: "close",
                                                    },
                                                    buttonType: "button"
                                                },
                                                {
                                                    buttonProps: {
                                                        btnText: "Submit",
                                                        type: "submit",
                                                        isLoading: updateJurisdictionsCollectorRes.isLoading,
                                                    },
                                                    buttonType: "button",
                                                }
                                            ]}
                                            align={"end"}
                                            gap={2}
                                        />

                                    </div>
                                </>
                            }
                        />
                        {showCollectorModal && (
                            <CommonSelectorModal
                                title="Collector Selector"
                                columns={columns}
                                data={useSearchCollectorQuery}
                                show={showCollectorModal}
                                onSubmit={handleOnClick}
                                setShow={setShowCollectorModal}
                                setSelectedRow={setSelectedRow}
                            />
                        )
                        }
                    </>
                }

            />

        </>


    );
}